import React from "react";
import classNames from "classnames";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import {Card, CardContent} from "@material-ui/core";
import APPCONFIG from "constants/Config";
import moment from "moment";

export default class Analytics extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Dealers_Missing_Email_Logs._name, API.RequestType.READ_ALL);
		super(props, model);
		this.loadDealerRatio().then();
	}



	loadDealerRatio = async () => {
		let dealerRatioModel = new API.BuildClass(Types.Dealers_Missing_Email_Logs._name, 'GET_DEALER_EMAIL_RATIO');
		dealerRatioModel.parent = '9999-99999999';
		let result = await dealerRatioModel.submit(this, 'GET_DEALER_EMAIL_RATIO');
		this.setState({
			different: result.different,
			percentage: result.percentage,
			ratio: result.ratio,
			total: result.total,
			actual_total: result.actual_total_count,
		})
	}


	render() {
		const {data, pages, limit, loading} = this.state;
		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('Dealers Email Logs')}
								<div style={{
									backgroundColor: '#f8f9fa',
									border: '1px solid #dee2e6',
									borderRadius: '8px',
									padding: '24px 32px',
									marginBottom: '20px',
									fontSize: '18px',
									color: '#495057',
									width: '600px',
									boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
									lineHeight: '1.5',
									margin: '0 auto 20px auto',
									textAlign: 'center'
								}}>

									<div style={{marginBottom: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
										<span style={{marginRight: '8px'}}>📊</span>
										<span>The link has been shown&nbsp;</span>
										<strong style={{color: '#007bff', fontSize: '20px'}}>{this.state.actual_total || 0}</strong>
										<span>&nbsp;times</span>
									</div>

									<div style={{marginBottom: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
										<span style={{marginRight: '8px'}}>🔗</span>
										<span>The link has been clicked&nbsp;</span>
										<strong style={{color: '#28a745', fontSize: '20px'}}>{this.state.total || 0}</strong>
										<span>&nbsp;times</span>
									</div>

									<div style={{marginBottom: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
										<span style={{marginRight: '8px'}}>📧</span>
										<strong style={{color: '#dc3545', fontSize: '20px'}}>{this.state.different || 0}</strong>
										<span>&nbsp;record(s) have changed emails</span>
									</div>

									<div style={{
										backgroundColor: '#007bff',
										color: 'white',
										padding: '8px 16px',
										borderRadius: '20px',
										fontSize: '16px',
										fontWeight: 'bold',
										display: 'inline-block',
										boxShadow: '0 2px 4px rgba(0,123,255,0.3)'
									}}>
										{this.state.percentage ? `${this.state.percentage.toFixed(1)}% success rate Link Shown/Changed Emails` : '0% success rate Link Shown/Changed Emails'}
									</div>
								</div>

								<div className="ml-auto refresh">
									<Button color="secondary" onClick={this.reloadTable}><i
										className={"fa fa-refresh"}/></Button>
								</div>
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={[
								{
									Header: "Account",
									id: "account",
									accessor: (obj) => obj.accounts ? obj.accounts.pkey : '',
								},
								{
									Header: "Dealer Pkey",
									accessor: "dealer"
								},
								{
									Header: "Dealer",
									id: 'dealer_name',
									accessor: obj => obj.dealers ? obj.dealers.name_company ?? obj.dealers.name_display ?? obj.dealers.name_trade : ''
								},
								{
									Header: "Date Ignored",
									id: "date_ignored",
									accessor: obj => {
										return obj.date_ignored ? moment(obj.date_ignored).local().format("MM/DD/YYYY h:mm A") : '-'
									}
								},
								{
									Header: "FFL Type",
									id: "ffl_type",
									accessor: obj => obj.ffl_types ? obj.ffl_types.type : obj.ffl_type
								},
								{
									Header: "Previous Email",
									id: "previous_email",
									accessor: obj => obj.prev_email
								},
								{
									Header: "New Email",
									id: "new_email",
									accessor: obj => obj.new_email
								},

							]}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={pages > 1}
							defaultPageSize={limit}
							className="-striped -highlight"
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}